var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#171926;stroke:#fff;stroke-width:0.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(-23882 -22518)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23882 22518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23891.18 -22515)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.91,14.254l-.646-.366a9.952,9.952,0,0,0,0-2.776l.646-.366a2.474,2.474,0,0,0,.929-3.411l-1.275-2.17a2.571,2.571,0,0,0-3.473-.915l-.646.366A10.217,10.217,0,0,0,28,3.227V2.495A2.521,2.521,0,0,0,25.455,0H22.9a2.522,2.522,0,0,0-2.543,2.495v.732a10.217,10.217,0,0,0-2.447,1.39l-.646-.366a2.569,2.569,0,0,0-3.473.915l-1.275,2.17a2.475,2.475,0,0,0,.929,3.411l.646.366a9.952,9.952,0,0,0,0,2.776l-.646.366a2.474,2.474,0,0,0-.929,3.411l1.275,2.17a2.571,2.571,0,0,0,3.473.915l.646-.366a10.217,10.217,0,0,0,2.447,1.39v.732A2.521,2.521,0,0,0,22.9,25h2.551A2.522,2.522,0,0,0,28,22.505v-.732a10.217,10.217,0,0,0,2.447-1.39l.646.366a2.569,2.569,0,0,0,3.473-.915l1.275-2.17A2.475,2.475,0,0,0,34.91,14.254Zm-3.167-2.8a7.492,7.492,0,0,1,0,2.089l-.236,1.667,2.126,1.206-1.273,2.165-2.13-1.208-1.353,1.039a7.661,7.661,0,0,1-1.835,1.042l-1.59.632V22.5H22.907V20.088l-1.59-.632a7.66,7.66,0,0,1-1.835-1.042l-1.353-1.039L16,18.583l-1.273-2.165,2.126-1.206-.236-1.667a7.493,7.493,0,0,1,0-2.089l.236-1.667L14.726,8.583,16,6.418l2.13,1.208,1.353-1.039a7.661,7.661,0,0,1,1.835-1.042l1.59-.632V2.5h2.545V4.912l1.59.632a7.66,7.66,0,0,1,1.835,1.042L30.23,7.626l2.13-1.208,1.273,2.165L31.507,9.788Z",
    transform: "translate(-12.18)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.089 7.409)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M133.091,128a5.091,5.091,0,1,0,5.091,5.091A5.091,5.091,0,0,0,133.091,128Zm0,7.636a2.545,2.545,0,1,1,2.545-2.545A2.545,2.545,0,0,1,133.091,135.636Z",
    transform: "translate(-128 -128)"
  }))))));
};
export default SvgSettings;